import { reloadData } from '@axo/form/data-access/backend-sync';
import { useTranslation } from '@axo/shared/i18n';
import { Toast } from '@axo/ui-core/components/Toast';
import { ComponentProps, useCallback, useMemo } from 'react';
import { ErrorToastProps } from '../ErrorToast';

export const ApplicationClosed = ({ error, onClose }: ErrorToastProps) => {
  const { t } = useTranslation();

  const url = useMemo(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    url.searchParams.delete('step');
    return url;
  }, []);

  const onStartNew = useCallback(() => {
    reloadData.reset();
    window.location.assign(url.href);
  }, [url]);

  const action: ComponentProps<typeof Toast>['action'] = useMemo(
    () => ({
      label: t('ErrorToast.ApplicationClosed.cta.start'),
      onClick: onStartNew,
    }),
    [t, onStartNew]
  );

  return (
    <Toast
      isOpen={!!error}
      onClose={onClose}
      feedbackState="error"
      title={t('ErrorToast.ApplicationClosed.title')}
      description={t('ErrorToast.ApplicationClosed.description')}
      action={action}
    />
  );
};
